module.exports = __webpack_public_path__ + "static/assets/ec42dec886c8f6f5ef02237e9d56d2a7.gif";